module.exports = __webpack_public_path__ + "static/img/9.22ed021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news14/9.png
// module id = JIS+
// module chunks = 1